/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { UpdateOrganizationMutationRequest, UpdateOrganizationMutationResponse, UpdateOrganizationPathParams, UpdateOrganization400, UpdateOrganization401, UpdateOrganization403, UpdateOrganization404, UpdateOrganization409, UpdateOrganization500 } from "../../types/organizationController/UpdateOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getUpdateOrganizationUrl(organizationId: UpdateOrganizationPathParams["organizationId"]) {
  const res = { method: 'PUT', url: `/api/organizations/${organizationId}` as const }
  return res
}

/**
 * @summary Update organization
 * {@link /api/organizations/:organizationId}
 */
export async function updateOrganization(organizationId: UpdateOrganizationPathParams["organizationId"], data: UpdateOrganizationMutationRequest, config: Partial<RequestConfig<UpdateOrganizationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateOrganizationMutationResponse, ResponseErrorConfig<UpdateOrganization400 | UpdateOrganization401 | UpdateOrganization403 | UpdateOrganization404 | UpdateOrganization409 | UpdateOrganization500>, UpdateOrganizationMutationRequest>({ method : "PUT", url : getUpdateOrganizationUrl(organizationId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}